"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildPathAndQuery = void 0;
const buildPathAndQuery = (pattern, params) => {
    let path = pattern;
    const paramsToReplace = (path.match(new RegExp(`:[a-zA-Z]+`, 'g')) || []).map((v) => v.replace(/^:/, ''));
    for (const key of paramsToReplace) {
        path = path.replace(new RegExp(`:${key}`, 'g'), encodeURIComponent(params.path[key]));
    }
    const query = Object.entries(params.query)
        .filter(([_, value]) => !!value)
        .map(([key, value]) => `${key}=${encodeURIComponent(value.toString())}`)
        .join('&');
    return query === '' ? path : `${path}?${query}`;
};
exports.buildPathAndQuery = buildPathAndQuery;
